// extracted by mini-css-extract-plugin
export default {"SliderContainer":"CustomSlider_SliderContainer__0oSLo","SliderValue":"CustomSlider_SliderValue__ugTO3"};